import { updateCasePlanWidgetConfig } from '../../api/casePlanDetailApi';
import { rollbackFormsWidgetFormIds } from './formsWidgetRollback.util';
import { notifyFormsWidgetError } from './formsWidgetToast.util';
import { toFormsWidgetConfig } from './formsWidgetConfig.util';
import { replaceFormsWidgetFormIds } from './formsWidgetSection.util';

/** Applies one optimistic Forms config update and restores the prior ids when persistence fails. */
export const persistFormsWidgetFormIds = async ({
  casePlanId,
  widgetId,
  previousFormIds,
  nextFormIds,
  setSections,
  errorMessage,
}) => {
  setSections((current) => replaceFormsWidgetFormIds(current, widgetId, nextFormIds));

  try {
    await updateCasePlanWidgetConfig(casePlanId, widgetId, toFormsWidgetConfig(nextFormIds));
  } catch {
    setSections((current) =>
      rollbackFormsWidgetFormIds(current, widgetId, {
        optimisticFormIds: nextFormIds,
        previousFormIds,
      }),
    );
    notifyFormsWidgetError(errorMessage);
  }
};
